import React from 'react';

import styled from '@emotion/styled';

import TableSliderContentWrapper from '../TableAccessories/TableSliderContentWrapper';

interface DemoRequestDataProps {
  data?: Record<string, any>;
}

const DemoRequestData: React.FC<DemoRequestDataProps> = ({ data }) => {
  // const { requestDemoInfo, loading } = useRequestDemoInformation();
  // const tableContext = useContext(TableContext);

  // useEffect(() => {
  //   if (tableContext?.showTableSlide) {
  //     requestDemoInfo(data?.id);
  //   }
  //   // eslint-disable-next-line
  // }, [data?.id]);

  return (
    <TableSliderContentWrapper
      label={data?.companyName ?? ''}
      // loading={loading}
    >
      <Section>
        <Cell>
          <CellLabel>Website URL</CellLabel>
          <div>{data?.websiteUrl ?? '--'}</div>
        </Cell>
        <Cell>
          <CellLabel>Country</CellLabel>
          <div>{data?.country ?? '--'}</div>
        </Cell>
        <Cell>
          <CellLabel>Current Number of Fleets</CellLabel>
          <div>{data?.fleetSize ?? '--'}</div>
        </Cell>
        <Cell>
          <CellLabel>Message</CellLabel>
          <TextArea>{data?.message ?? '--'}</TextArea>
        </Cell>
      </Section>
    </TableSliderContentWrapper>
  );
};

export default DemoRequestData;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  /* border: 1px solid red; */

  border-top: 1px solid ${({ theme }) => theme.palette.borderColor};
  padding-top: 8px;
`;

const Cell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-weight: 600;
  font-size: 14px;
  padding: 12px;
  color: ${({ theme }) => theme.palette.grayTextColor};
  background-color: rgba(250, 250, 250, 0.8);
`;

const CellLabel = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.palette.darkGrayText};
  /* border: 1px solid blue; */
`;

const TextArea = styled.div`
  background-color: white;
  padding: 12px;
  border: 600;
  color: ${({ theme }) => theme.palette.grayTextColor};
`;
